import React, { useState, useContext, useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/legacy/image";
import dynamic from "next/dynamic";
import { Store } from "@store";
import { appBaseUrl } from "@base-url";
import PropTypes from "prop-types";
import { getCount } from "@utils/metrics/countMetric";
import classes from "@styles/profile/profile.module.css";
import addMemberClasses from "@styles/community/addmember.module.css";
import defaultcoverpic from "@public/assets/images/cover.png";
import defaultCommitteePic from "@public/assets/images/committee.png";
import shareIcon from "@public/ic_share_custom.png";
import { purple } from "@mui/material/colors";
import { ThemeProvider } from "styled-components";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { FEED_TYPES, COMMUNITY_MEMBER_ROLES, COMMUNITY_SECURITY_TYPES, HTTP_STATUS_CODES } from "@utils/constants";
import { deleteCommunity, reportCommunity, updateDpCover, leaveMembership, requestToJoin } from "@queries/community.queries";
import { ModeEditOutlineOutlined as EditIcon, OpenInNew as OpenInNewIcon, MoreVert as MoreVertIcon, Verified as VerifiedIcon, LockOpen as LockOpenIcon, Lock as LockIcon } from "@mui/icons-material";
import { Modal, Tooltip, Tabs, Tab, createTheme, ClickAwayListener } from "@mui/material";
import { NoSsr } from "@mui/material";
import Sidebar from "./CommunityProfileSidebar";
import UpvoteDialog from "./UpvoteDialog";
import BlockedUserModal from "@components/modal/BlockedUserModal";
import GuestUserModal from "src/globalModule/components/guestUserModal";
// const Sidebar = dynamic(() => import("./ComunityProfileSidebar"), {
//   ssr: false,
// });

/*---------------------- To be loaded at client-side only ---------------------------*/

/* icons */
const CommunityType = dynamic(() => import("@public/assets/icons/pujocategory.svg"), {
  ssr: false
});
const PersonAddIcon = dynamic(() => import("@public/assets/icons/add_user.svg"), {
  ssr: false
});
/* ------- */

// import CommunityProfileFeeds from "./CommunityProfileFeeds";
const CommunityProfileFeeds = dynamic(() => import("./CommunityProfileFeeds"), {
  ssr: false
});
const CommunitySinglePostView = dynamic(() => import("./CommunitySinglePostView"), {
  ssr: false
});
const CommunityEvents = dynamic(() => import("./CommunityEvents"), {
  ssr: false
});
const ContactTab = dynamic(() => import("./ContactTab"), {
  ssr: false
});
const Members = dynamic(() => import("./Members"), {
  ssr: false
});
const CommunityAddMember = dynamic(() => import("./CommunityAddMember"), {
  ssr: false
});
const RWebShare = dynamic(() => import("react-web-share").then(mod => mod.RWebShare), {
  ssr: false
});
// const UpvoteDialog = dynamic(
//   () => import("@components/community/UpvoteDialog"),
//   {
//     ssr: false,
//   }
// );
const UtsavModal = dynamic(() => import("src/globalModule/components/UtsavModal"), {
  ssr: false
});
const CreatePost = dynamic(() => import("@components/createPost/CreatePost"), {
  ssr: false
});
const Cropper = dynamic(() => import("@components/cropper/Cropper"), {
  ssr: false
});
const CommunityEditProfile = dynamic(() => import("@components/community/CommunityEditProfile"), {
  ssr: false
});
const FullScreenViewImage = dynamic(() => import("@components/imageView/FullScreenImageView"), {
  ssr: false
});
/*--------------------------- components end ------------------------------*/

export default function CommunityProfile({
  data
}) {
  const {
    t
  } = useTranslation();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const router = useRouter();
  const {
    tabNo
  } = router.query;
  const [value, setValue] = useState(tabNo ? tabNo : 1);
  const [profile_pic, setProfilePic] = useState(data?.dp);
  const [cover_pic, setCoverpic] = useState(data?.coverPic || defaultcoverpic);
  const visits = data.CommunityMetric.visitNo;
  const members = data.CommunityMetric.memberNo;
  const likes = data.CommunityMetric.likeNo;
  const [joined, setJoined] = useState();
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const [showMore, setShowMore] = useState(true);
  const [role, setRole] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [smallScreen, setSmallScreen] = useState(false);
  const {
    share
  } = router.query;
  const shareEnable = React.createRef();
  const profileLink = `${appBaseUrl}/${router.locale}/community/${data.urlExtension}`;
  // const share_url = profileLink;
  // let share_url;
  // if (loggedInUser.referralID) {
  //   share_url = `\n${profileLink} \n\nDownload Utsav App👇 \nhttps://utsavapp.in/download?referrer=${loggedInUser.referralID}`;
  // } else {
  //   share_url = `\n${profileLink} \n\nDownload Utsav App👇 \nhttps://utsavapp.in/download`;
  // }

  useEffect(() => {
    if (shareEnable.current !== null && share) {
      shareEnable.current.click();
    }
  }, [shareEnable, share]);
  useEffect(() => {
    setJoined(membershipStatus(data?.CommunityMember?.role));
    setRole(data?.CommunityMember?.role);
    setIsAdmin(data?.CommunityMember?.role === COMMUNITY_MEMBER_ROLES.OWNER || data?.CommunityMember?.role === COMMUNITY_MEMBER_ROLES.ADMIN ? true : false);
    setProfilePic(data.dp);
    if (data.coverPic) {
      setCoverpic(data.coverPic);
    }
    if (typeof window !== "undefined" && window.innerWidth < 992) {
      setSmallScreen(true);
    }
  }, [data]);

  ///=== For Cropper =====////
  const [upImgProfile, setUpImgProfile] = useState();
  const [upImgCover, setUpImgCover] = useState();
  const [openEditModalProfile, setOpenEditModalProfile] = useState(false);
  const [openEditModalCover, setOpenEditModalCover] = useState(false);
  const [filename, setFilename] = useState("");
  const [profilePicUpload, setProfilePicUpload] = useState(null);

  // --UtsavModal config
  const [openLeaveModal, setOpenLeaveModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [openReportSuccessModal, setOpenReportSuccessModal] = useState(false);
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [openFullImage, setOpenFullImage] = useState(false);
  const [openBlockedUserModal, setOpenBlockedUserModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const toggleBlockedServiceModal = () => {
    setOpenBlockedUserModal(!openBlockedUserModal);
  };
  const [openUnauthorizedModal, setOpenUnauthorizedModal] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const handleOpenUnauthorizedModal = () => {
    setOpenUnauthorizedModal(cur => !cur);
  };
  const cx = classNames.bind(classes);
  const roleStyle = cx({
    member: joined === "member",
    join: joined === "join",
    requested: joined === "requested"
  });
  const address = data.CommunityAddress?.address ?? "";
  const city = data.CommunityAddress?.city ?? "";
  const stateC = data.CommunityAddress?.state ?? "";
  function membershipStatus(role) {
    let status;
    switch (role) {
      case COMMUNITY_MEMBER_ROLES.REQUESTED:
        status = "requested";
        break;
      case COMMUNITY_MEMBER_ROLES.GENERAL:
        status = "member";
        break;
      case COMMUNITY_MEMBER_ROLES.ADMIN:
        status = "member";
        break;
      case COMMUNITY_MEMBER_ROLES.OWNER:
        status = "member";
        break;
      default:
        status = "join";
        break;
    }
    return status;
  }

  //const profileLink = `https://fe.utsavapp.in/community/${data.urlExtension}`;
  const theme = createTheme({
    palette: {
      primary: {
        light: purple[600],
        main: purple[800]
      }
    }
  });
  const toggleLeaveModal = () => {
    setOpenLeaveModal(cur => !cur);
  };
  const toggleReportModal = () => {
    setOpenReportModal(cur => !cur);
  };
  const toggleReportSuccessModal = () => {
    setOpenReportSuccessModal(cur => !cur);
  };
  const toggleDeleteModal = e => {
    setOpenDeleteModal(cur => !cur);
  };
  const startCrop = (file, type) => {
    if (file) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        if (type === "profile") setUpImgProfile(reader.result);else setUpImgCover(reader.result);
      });
      reader.readAsDataURL(file);
    }
  };

  ////======= FULLSCREEN IMAGE VIEW COMPONENT START ======///
  function viewFullImage(imgsrc, type) {
    let flag = true;
    if (type === "cover" && (!cover_pic || cover_pic === defaultcoverpic)) flag = false;
    if (type === "profile" && !profile_pic) flag = false;
    if (flag) {
      setViewImage(imgsrc);
      setOpenFullImage(true);
    }
  }
  ////======= FULLSCREEN IMAGE VIEW COMPONENT END ======///

  ////////======= PROFILE AND COVER PICTURE UPDATE START ======///////

  const handleImageUpload = async image => {
    //printInConsole(image);

    if (profilePicUpload) updateprofilepicdata(image);else if (!profilePicUpload) updatecoverpicdata(image);
    setProfilePicUpload(null);
  };
  const handleImageChange = (e, type) => {
    if (e.target.files && e.target.files.length > 0) {
      const fname = e.target.files[0].name;
      if (fname.endsWith(".jpg") || fname.endsWith(".jpeg") || fname.endsWith(".png")) {
        const imageFile = e.target.files[0];
        startCrop(imageFile, type);
        if (type === "profile") setOpenEditModalProfile(true);else setOpenEditModalCover(true);
        setFilename(fname);
      } else {
        setModalHeading("Invalid Format.");
        setModalMessage("This format is not supported.");
        toggleModal();
      }
    }
  };
  const uploadProfilePicture = e => {
    if (e.target.files[0]) {
      setProfilePicUpload(true);
      handleImageChange(e, "profile");
    }
  };
  const uploadCoverPicture = e => {
    if (e.target.files[0]) {
      setProfilePicUpload(false);
      handleImageChange(e, "cover");
    }
  };
  function changeProfilePicture() {
    const a = document.getElementById("profile-picture-file-input");
    a.value = "";
    a.click();
    // trackEvent("Profile Edit", {
    //   Source: "Dp",
    // });
  }
  function changeCoverPicture() {
    const b = document.getElementById("cover-picture-file-input");
    b.value = "";
    b.click();
    // trackEvent("Profile Edit", {
    //   Source: "Cover",
    // });
  }
  async function updateprofilepicdata(img) {
    const result = await updateDpCover({
      communityID: data.communityID,
      file: img,
      type: FEED_TYPES.DP,
      data: {
        uid: loggedInUser.uid
      },
      accessToken: loggedInUser.accessToken
    });
    if (result && result.length > 0) {
      setProfilePic(result[0]);
    }
  }
  async function updatecoverpicdata(link) {
    const result = await updateDpCover({
      communityID: data.communityID,
      file: link,
      type: FEED_TYPES.COVER,
      data: {
        uid: loggedInUser.uid
      },
      accessToken: loggedInUser.accessToken
    });
    if (result && result?.length > 0) {
      setCoverpic(result[0]);
    }
  }

  ////////======= PROFILE AND COVER PICTURE UPDATE START ======///////

  //////======= TAB CHANGE FUNCTION ======/////
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  ////////======= UPDATE PROFILE DATA START ======///////

  function openEditCommunity() {
    // trackEvent("Profile Edit", {
    //   Source: "Profile Page",
    // });
    setShowEditProfile(true);
  }
  const EditProfileModal = () => {
    function closeModal() {
      setShowEditProfile(false);
    }
    return <>
        <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="CommunityProfile.jsx">
          <Modal open={showEditProfile} data-sentry-element="Modal" data-sentry-source-file="CommunityProfile.jsx">
            <div className={`${classes.editProfile_overlay}`}>
              <div className={`${classes.editProfile}`}>
                <CommunityEditProfile data={data} close={closeModal} data-sentry-element="CommunityEditProfile" data-sentry-source-file="CommunityProfile.jsx" />
              </div>
            </div>
          </Modal>
        </NoSsr>
      </>;
  };
  const AddMemberModal = () => {
    function closeModal() {
      setAddMemberModal(false);
    }
    return <>
        <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="CommunityProfile.jsx">
          <Modal open={addMemberModal} data-sentry-element="Modal" data-sentry-source-file="CommunityProfile.jsx">
            <div className={`${addMemberClasses.addMember_overlay}`}>
              <div className={`${addMemberClasses.addMember}`}>
                <CommunityAddMember close={closeModal} data-sentry-element="CommunityAddMember" data-sentry-source-file="CommunityProfile.jsx" />
              </div>
            </div>
          </Modal>
        </NoSsr>
      </>;
  };

  ////////======= UPDATE PROFILE DATA END ======///////
  async function joinClickHandler(event) {
    let btn = null;
    if (event) {
      btn = event.target;
      btn.disabled = true;
    }
    if (!loggedInUser.authType) {
      // setOpenUnauthorizedModal(true);
      // if (smallScreen) setLoginModalOpen(true);
      setLoginModalOpen(true);
      if (btn) btn.disabled = false;
      return () => {};
    }
    if (joined === "join") {
      const res = await requestToJoin({
        communityID: data.communityID,
        accessToken: loggedInUser.accessToken
      });
      if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
        setErrorMsg(res.message);
        toggleBlockedServiceModal();
        return () => {};
      }
      if (res.success) {
        data.CommunityMember = res?.response;
      }
      if (data.securityType === COMMUNITY_SECURITY_TYPES.PUBLIC) {
        setJoined("member");
      } else {
        setJoined("requested");
      }
      // trackEvent("Community Joined", {
      //   Source: "Community Page",
      // });
    } else {
      toggleLeaveModal();
    }
    if (btn) btn.disabled = false;
  }
  async function leaveCommunity() {
    const res = await leaveMembership({
      uid: loggedInUser.uid,
      memberID: data.CommunityMember.memberID,
      accessToken: loggedInUser.accessToken
    });
    if (res) {
      setJoined("join");
      setOpenLeaveModal(cur => !cur);
      data.CommunityMember = null;
    } else {
      alert("Something went wrong!");
    }
  }
  function showmore() {
    setShowMore(!showMore);
  }
  const coverPicLoadErrorHandler = e => {
    e.target.src = defaultcoverpic;
  };
  function viewLocation() {
    let text = `${address ? address + ", " : ""}${city ? city + ", " : ""}${stateC ? stateC : ""}`;
    text = encodeURIComponent(text);
    window.open(`https://www.google.com/maps/search/${text}`);
  }
  const handleReport = async () => {
    const res = await reportCommunity({
      communityID: data.communityID,
      accessToken: loggedInUser.accessToken
    });
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    // toggleReportModal();
    if (res.success) toggleReportSuccessModal();else alert("You have already reported this community!");
  };
  const handleDelete = async () => {
    const res = await deleteCommunity({
      communityID: data.communityID,
      ownerUid: data.ownerUid,
      accessToken: loggedInUser.accessToken
    });
    if (res) {
      router.push("/home");
    } else alert("Something went wrong!");
  };
  function MoreOptions() {
    if (!loggedInUser.authType) {
      // setOpenUnauthorizedModal(true);
      // if (smallScreen) setLoginModalOpen(true);
      setLoginModalOpen(true);
      return <></>;
    }
    return <div className={classes.profileMoreOptions} data-sentry-component="MoreOptions" data-sentry-source-file="CommunityProfile.jsx">
        {loggedInUser.uid === data.ownerUid ? <p onClick={toggleDeleteModal}>Delete</p> : <p onClick={toggleReportModal}>Report</p>}
      </div>;
  }
  function handleClickAway() {
    //setShowMoreOptions((cur) => !cur);
  }
  function showCommunityTab() {
    if (window.innerWidth < 992) {
      setValue(4);
    }
  }
  return <>
      <div className={`${classes.profile}`}>
        <div className={`${classes.profile_display}`}>
          <div className={classes.profile_display_inner_left}>
            <div className={`${classes.profile_display_cover}`}>
              <div>
                <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="CommunityProfile.jsx">
                  <ClickAwayListener onClickAway={handleClickAway} data-sentry-element="ClickAwayListener" data-sentry-source-file="CommunityProfile.jsx">
                    <button className={`${classes.btn} ${classes.profile_display_cover_more}`} onClick={() => setShowMoreOptions(cur => !cur)} color="success">
                      <MoreVertIcon data-sentry-element="MoreVertIcon" data-sentry-source-file="CommunityProfile.jsx" />
                    </button>
                  </ClickAwayListener>
                </NoSsr>

                {showMoreOptions && <>
                    <NoSsr>
                      <MoreOptions />
                    </NoSsr>
                  </>}
              </div>
              <div className={`${classes.profile_display_cover_img}`} onClick={() => viewFullImage(cover_pic, "cover")}>
                <Image src={cover_pic} alt={data.name + "-cover"} id="coverPicture" layout="fill" priority onError={coverPicLoadErrorHandler} data-sentry-element="Image" data-sentry-source-file="CommunityProfile.jsx" />
              </div>
              <input type="file" accept="image/*" id="cover-picture-file-input" hidden="hidden" onChange={uploadCoverPicture} />

              {loggedInUser.uid === data.ownerUid && <NoSsr>
                  <Tooltip title="Edit Cover picture" placement="bottom">
                    <button className={`${classes.profile_display_cover_edit} ${classes.btn}`} onClick={changeCoverPicture}>
                      <EditIcon fontSize="small" />
                    </button>
                  </Tooltip>
                </NoSsr>}
            </div>

            <div className={`${classes.profile_display_about}`}>
              <div className={`${classes.profile_display_row}`}>
                <div className={`${classes.profile_display_about_com}`}>
                  <>
                    <RWebShare data={{
                    text: `Join ${data.name} on Utsav! - `,
                    url: profileLink,
                    // url: share_url,
                    title: "Utsav"
                  }} sites={["whatsapp", "mail", "linkedin", "telegram"]} onClick={() => {}} className={`${classes.profile_display_about_share}`} data-sentry-element="RWebShare" data-sentry-source-file="CommunityProfile.jsx">
                      <button className={`${classes.btn} ${classes.profile_display_about_share}`}>
                        <Image src={shareIcon} alt="Share Button" className={classes.shareIcon} height={25} width={25} data-sentry-element="Image" data-sentry-source-file="CommunityProfile.jsx" />
                      </button>
                    </RWebShare>
                  </>

                  <button className={`${classes.btn} ${classes.profile_display_about_add}`} onClick={() => setAddMemberModal(true)}>
                    <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="CommunityProfile.jsx">
                      <PersonAddIcon className={classes.personAddIcon} data-sentry-element="PersonAddIcon" data-sentry-source-file="CommunityProfile.jsx" />
                    </NoSsr>
                  </button>
                  {isAdmin ? <NoSsr>
                      <Tooltip title="Edit Profile" placement="right">
                        <button className={`${classes.profile_display_about_profile_edit}`} onClick={openEditCommunity}>
                          Edit Profile
                        </button>
                      </Tooltip>
                    </NoSsr> : <button className={`${classes.btn} ${roleStyle}`} onClick={joinClickHandler}>
                      {joined}
                    </button>}
                </div>

                <div>
                  <div className={`${classes.profile_display_about_imgC}`}>
                    <div className={`${classes.profile_display_about_img} ${classes.profile_dp_com}`}>
                      <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="CommunityProfile.jsx">
                        <div
                      // alt={data.name}
                      className={classes.profileAvatar} onClick={() => viewFullImage(profile_pic, "profile")}>
                          <Image src={profile_pic || defaultCommitteePic} alt={`${data.name} pic`} width="160" height="160" objectFit="cover" style={{
                          borderRadius: "50%"
                        }} data-sentry-element="Image" data-sentry-source-file="CommunityProfile.jsx" />
                        </div>
                      </NoSsr>
                    </div>

                    <input type="file" accept="image/*" id="profile-picture-file-input" hidden="hidden" onChange={uploadProfilePicture} />
                    {loggedInUser.uid === data.ownerUid && <NoSsr>
                        <Tooltip title="Edit Profile Picture" placement="right">
                          <button className={`${classes.btn} ${classes.profile_display_about_img_edit}`} onClick={changeProfilePicture}>
                            <EditIcon />
                          </button>
                        </Tooltip>
                      </NoSsr>}
                  </div>
                </div>

                <div className={classes.profile_display_container}>
                  <div className={`${classes.profile_display_middle}`}>
                    <div className={`${classes.profile_display_about_user_individual}`}>
                      <div className={`${classes.profile_display_about_user_name}`}>
                        <>{data.name}</>

                        {data.isVerified !== false && <NoSsr>
                            <VerifiedIcon htmlColor="#4c86f0" fontSize="24px" className={classes.verifcation} />
                          </NoSsr>}
                      </div>

                      {data.CommunityType.name !== "" && <div className={`${classes.profile_display_about_user_pujoCategory}`}>
                          <CommunityType className={classes.CommunityType} />
                          <span className={classes.communityTypeText}>
                            {data.OrganisationType !== null && <span className={classes.organisationTypeSpan}>
                                {data.OrganisationType.name}
                              </span>}
                            <span className={classes.communityNameSpan}>
                              {data.CommunityType.name}{" "}
                            </span>
                          </span>
                          {data.securityType === COMMUNITY_SECURITY_TYPES.PUBLIC ? <NoSsr>
                              <LockOpenIcon htmlColor="#5e17eb" className={classes.lockOpenIcon}
                        // style={{
                        //   margin: "-3px 0 0 8px",
                        //   fontSize: "1.2rem",
                        // }}
                        />
                            </NoSsr> : <NoSsr>
                              <LockIcon htmlColor="#5e17eb" className={classes.lockIcon} />
                            </NoSsr>}
                        </div>}
                      <div className={classes.count_section_left}>
                        <div className={`${classes.profile_display_about_user_span}`}>
                          <b>{getCount(visits)}</b>
                          <span className={`${classes.follows_upvotes_font}`}>
                            Visits
                          </span>
                        </div>
                        <div className={`${classes.profile_display_about_user_span}`} onClick={showCommunityTab}>
                          <b>{getCount(members)}</b>
                          <span className={`${classes.follows_upvotes_font}`}>
                            Members
                          </span>
                        </div>
                        <div className={`${classes.profile_display_about_user_span}`}>
                          <b>{getCount(likes)}</b>
                          <span className={`${classes.follows_upvotes_font}`}>
                            Likes
                          </span>
                        </div>
                      </div>
                      {data.headline ? <div className={`${classes.profile_display_user_about} ${classes.aboutColor}`}>
                          {data.headline?.length <= 120 && data.headline}
                          {data.headline?.length > 120 ? showMore ? data.headline.slice(0, 120) : data.headline.slice(0, data.headline.length + 1) : null}
                          {data.headline?.length > 120 ? !showMore ? <span className={`${classes.less_more}`} onClick={showmore}>
                                show less
                              </span> : <span className={`${classes.less_more}`} onClick={showmore}>
                                ...show more
                              </span> : null}
                        </div> : null}

                      <div className={`${classes.profile_display_about_user_all} ${classes.aboutColor}`}>
                        {`${address ? address + ", " : ""}${city ? city + ", " : ""}${stateC ? stateC : ""}`}{" "}
                        <span className={classes.locationIcon} onClick={viewLocation}>
                          <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="CommunityProfile.jsx">
                            <OpenInNewIcon fontSize="small" data-sentry-element="OpenInNewIcon" data-sentry-source-file="CommunityProfile.jsx" />
                          </NoSsr>
                        </span>
                      </div>
                      {smallScreen && <UpvoteDialog smallScreen={smallScreen} communityID={data?.communityID} communityTypeID={data?.typeID} isAdmin={isAdmin} upvotedStatus={data?.isUpvoted} upvoteNo={data?.CommunityMetric.upvoteNo} isUpvoting={data?.isUpvoting} />}
                    </div>
                  </div>
                </div>
              </div>

              <div className={classes.profile_tabs}>
                <div className={classes.tabs_switch_div}>
                  <ThemeProvider theme={theme} data-sentry-element="ThemeProvider" data-sentry-source-file="CommunityProfile.jsx">
                    <Tabs variant="scrollable" scrollButtons allowScrollButtonsMobile value={value} onChange={handleChange} TabIndicatorProps={{
                    style: {
                      background: "linear-gradient(90deg, #FF9800 0%, #FF5757 100%)",
                      color: "black",
                      fontSize: "20px"
                    }
                  }} data-sentry-element="Tabs" data-sentry-source-file="CommunityProfile.jsx">
                      <Tab label={t("Posts")} value={1} className={`${classes.tabs} ${value === 1 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="CommunityProfile.jsx" />
                      {/* <Tab
                        label={Clips}
                        value={2}
                        className={`${classes.tabs} ${
                          value === 2 ? classes.active_tab : ""
                        }`}
                       /> */}
                      <Tab label={t("Puja")} value={5} className={`${classes.tabs} ${value === 5 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="CommunityProfile.jsx" />
                      <Tab label={t("Contact")} value={3} className={`${classes.tabs} ${value === 3 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="CommunityProfile.jsx" />
                      {/* <Tab
                        label={Members}
                        value={4}
                        className={`${classes.tabs} ${classes.member_tab} ${
                          value === 4 ? classes.active_tab : ""
                        }`}
                       /> */}
                    </Tabs>
                  </ThemeProvider>
                </div>
              </div>
            </div>

            <TabPanel value={value} index={1} data-sentry-element="TabPanel" data-sentry-source-file="CommunityProfile.jsx">
              {value == 1 && <CommunityProfileFeeds communityID={data.communityID} postType={FEED_TYPES.IMAGE} />}
            </TabPanel>
            <TabPanel value={value} index={2} data-sentry-element="TabPanel" data-sentry-source-file="CommunityProfile.jsx">
              {value == 2 && <CommunityProfileFeeds communityID={data.communityID} postType={FEED_TYPES.VIDEO} />}
            </TabPanel>
            <TabPanel value={value} index={3} data-sentry-element="TabPanel" data-sentry-source-file="CommunityProfile.jsx">
              <ContactTab communityDetail={data.CommunityDetail} isAdmin={isAdmin} communityID={data.communityID} typeID={data.typeID} ownerUid={data.ownerUid} data-sentry-element="ContactTab" data-sentry-source-file="CommunityProfile.jsx" />
            </TabPanel>
            <TabPanel value={value} index={4} data-sentry-element="TabPanel" data-sentry-source-file="CommunityProfile.jsx">
              <Members communityID={data.communityID} isAdmin={isAdmin} showHeading={false} data-sentry-element="Members" data-sentry-source-file="CommunityProfile.jsx" />
            </TabPanel>
            <TabPanel value={value} index={5} data-sentry-element="TabPanel" data-sentry-source-file="CommunityProfile.jsx">
              <CommunityEvents communityID={data.communityID} data-sentry-element="CommunityEvents" data-sentry-source-file="CommunityProfile.jsx" />
            </TabPanel>
          </div>

          <Sidebar communityID={data.communityID} isAdmin={isAdmin} data={data} openEditCommunity={openEditCommunity} data-sentry-element="Sidebar" data-sentry-source-file="CommunityProfile.jsx" />
        </div>
      </div>

      <CommunitySinglePostView data-sentry-element="CommunitySinglePostView" data-sentry-source-file="CommunityProfile.jsx" />

      <FullScreenViewImage imageSrc={viewImage} openModal={openFullImage} closeModal={() => setOpenFullImage(false)} data-sentry-element="FullScreenViewImage" data-sentry-source-file="CommunityProfile.jsx" />

      <Cropper aspectRatio={1} image={upImgProfile} filename={filename} open={openEditModalProfile} setOpen={setOpenEditModalProfile} setImages={handleImageUpload} data-sentry-element="Cropper" data-sentry-source-file="CommunityProfile.jsx" />

      <Cropper aspectRatio={3} image={upImgCover} filename={filename} open={openEditModalCover} setOpen={setOpenEditModalCover} setImages={handleImageUpload} data-sentry-element="Cropper" data-sentry-source-file="CommunityProfile.jsx" />
      <AddMemberModal data-sentry-element="AddMemberModal" data-sentry-source-file="CommunityProfile.jsx" />

      <EditProfileModal data-sentry-element="EditProfileModal" data-sentry-source-file="CommunityProfile.jsx" />

      {data.CommunityMember && <CreatePost showPlusButton={true} community={{
      communityID: data.communityID,
      name: data.name,
      dp: data.dp,
      memberRole: data.CommunityMember.role
    }} />}

      {isLoginModalOpen && <GuestUserModal isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} handleBlogLoginModal={() => {
      setLoginModalOpen(false);
    }} />}

      {openReportModal && <UtsavModal open={openReportModal} toggleModal={toggleReportModal} heading={"Confirm Report"} message={"Are you sure want to Report this community ?"} acceptMsg={"Yes , Report"} onAccept={handleReport} rejectMsg="Cancel" positive={false} />}

      {openReportSuccessModal && <UtsavModal open={openReportSuccessModal} toggleModal={toggleReportSuccessModal} heading="Community Reported." message="The community has been reported." acceptMsg="Okay" />}

      {openDeleteModal && <UtsavModal open={openDeleteModal} toggleModal={toggleDeleteModal} heading={"Confirm Delete"} message={"Are you sure want to Delete this community ?"} acceptMsg={"Yes , Delete"} onAccept={handleDelete} rejectMsg={"Cancel"} positive={false} />}

      {openLeaveModal && <UtsavModal open={openLeaveModal} toggleModal={toggleLeaveModal} heading="Confirm Leave" message="Are you sure, you want to leave community?" acceptMsg="Yes, Leave" onAccept={leaveCommunity} rejectMsg="Cancel" positive={false} />}
      {openBlockedUserModal && <BlockedUserModal open={openBlockedUserModal} toggleModal={toggleBlockedServiceModal} message={errorMsg} acceptMsg="Contact Utsav" rejectMsg="Cancel" positive={true} />}
    </>;
}
function TabPanel(props) {
  const {
    value,
    index,
    ...other
  } = props;
  return <div role="tabpanel" hidden={value !== index} {...other} data-sentry-component="TabPanel" data-sentry-source-file="CommunityProfile.jsx"></div>;
}
TabPanel.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};